import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { type ReactNode } from 'react';

import { FullPage } from '@/components/page';
import { Link, Text } from '@/components/typography';
import { ROUTES } from '@/router';

import SignInPanel from '../SignInPanel';

type InstanceErrorProps = {
  title: ReactNode;
  message: ReactNode;
};

const InstanceError = ({ title, message }: InstanceErrorProps) => {
  return (
    <FullPage title={t`Sign In`}>
      <SignInPanel title={title}>
        <Text variant="body1" className="text-center">
          {message}
        </Text>
        <div className="mt-4 text-center">
          <Link variant="body1" color="aqua" to={ROUTES.signIn.path}>
            <Trans>Return to sign in</Trans>
          </Link>
        </div>
      </SignInPanel>
    </FullPage>
  );
};

export default InstanceError;
